import { Redirect } from 'expo-router';
import { useUserStore } from '@/state/userStore';
import { LoadingState } from '@/components/ui/LoadingState';

export default function RootIndex() {
  const authReady = useUserStore((state) => state.authReady);
  const isAuthenticated = useUserStore((state) => state.isAuthenticated);
  const needsEmailVerification = useUserStore((state) => state.needsEmailVerification);
  const hasCompletedOnboarding = useUserStore((state) => state.hasCompletedOnboarding);

  if (!authReady) {
    return <LoadingState variant="fullscreen" message="Initializing..." />;
  }

  if (isAuthenticated && needsEmailVerification) {
    return <Redirect href="/(onboarding)/verify-email" />;
  }

  if (isAuthenticated && hasCompletedOnboarding) {
    return <Redirect href="/(tabs)" />;
  }

  if (isAuthenticated && !hasCompletedOnboarding) {
    return <Redirect href="/(onboarding)/profile-details" />;
  }

  return <Redirect href="/(onboarding)/value-proposition" />;
}
